import { render, staticRenderFns } from "./SidePaddedImageSlider.vue?vue&type=template&id=4c167653"
import script from "./SidePaddedImageSlider.vue?vue&type=script&lang=js"
export * from "./SidePaddedImageSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports